<template>
    <div class="recruitmentContainer">
        <div class="flex">
            <div><img width="10" src="../../assets/MK体育 - MK(中国)一站式服务官方网站/about/1.png" alt=""></div>
            <div class="padding-left-20">
                <div><h1 style="font-weight: bold"> 广州mk体育智能科技有限公司招聘信息</h1></div>
                <div><p> Guangzhou MK体育 - MK(中国)一站式服务官方网站 Intelligent Technology Co.,Ltd</p></div>
            </div>
        </div>
        <div class="item">
            <h3>招聘岗位:前端工程师</h3>
            <ul class="yaoqiu">
                <li>经验要求：1-3年</li>
                <li>职位性质：全职</li>
                <li>学历要求：不限</li>
                <li>招聘人数：1人</li>
            </ul>
            <p>职位描述</p>
            <p>岗位职责：<br>
                1. 负责项目Web平台的设计与开发；（包括PC、以及移动端开发）<br>
                2. RestAPI接口开发工作；<br>
                3. 根据产品需求，对产品的整体美术风格、交互设计、界面结构、操作流程等做出设计；<br>
                4. 与产品经理紧密配合，完成项目的持续交付；<br>
                任职要求：<br>
                1. 至少完整经历过一个产品的开发、上线、维护工作，对Web开发有整体认识；<br>
                2. 熟悉并掌握至少一款主流的前端开发框架（Vue、AngularJs、React）等，了解MVC开发模式；<br>
                3. 熟悉Tomcat、Nginx中任一种应用服务器的开发和相关配置；<br>
                4. 熟练使用git管理工具</p>
            <ul class="contact">
                <li>工作地点:{{addressLocat}}</li>
                <li>邮箱1:{{email1}}</li>
                <li>邮箱2:{{email2}}</li>
                <li>联系电话:{{phone}}</li>
            </ul>
        </div>
        <div class="item">
            <h3>招聘岗位:测试工程师</h3>
            <ul class="yaoqiu">
                <li>经验要求：1-3年</li>
                <li>职位性质：全职</li>
                <li>学历要求：不限</li>
                <li>招聘人数：1人</li>
            </ul>
            <p>职位描述</p>
            <p>岗位职责：<br>
                1、负责机器人产品测试用例的编写<br>
                2、负责pc端、APP以及后台系统的功能测试，界面测试，接口测试，性能测试<br>
                3、熟悉基本的adb指令和MySql数据库语句<br>
                4、熟悉常用的测试工具selenium，appium，jmeter，fiddler，postman，熟悉测试分析技术，有较强的逻辑分析能力和总结能力<br>
                5、熟悉PHP/java/python 等语言优先考虑<br>
                6、对bug有较高的敏锐性，并且能及时跟进问题的进度</p>
            <ul class="contact">
                <li>工作地点:{{addressLocat}}</li>
                <li>邮箱1:{{email1}}</li>
                <li>邮箱2:{{email2}}</li>
                <li>联系电话:{{phone}}</li>
            </ul>
        </div>
        <div class="item">
            <h3>招聘岗位:Android工程师</h3>
            <ul class="yaoqiu">
                <li>经验要求：3-5年</li>
                <li>职位性质：全职</li>
                <li>学历要求：不限</li>
                <li>招聘人数：1人</li>
            </ul>
            <p>职位描述</p>
            <p>岗位职责：<br>
                1. 有扎实的java编程基础<br>
                2. 熟悉Android相关架构，熟练开发、调试、适配程序<br>
                3. 有智能硬件开发经验<br>
                4. 有较强的团队合作精神，积极主动、经验分享<br>
                5. 熟练使用android studio开发工具，git版本管理<br>
                6. 表现优秀者有项目奖励与期权奖励<br></p>
            <ul class="contact">
                <li>工作地点:{{addressLocat}}</li>
                <li>邮箱1:{{email1}}</li>
                <li>邮箱2:{{email2}}</li>
                <li>联系电话:{{phone}}</li>
            </ul>
        </div>
        <div class="item">
            <h3>招聘岗位:装配员</h3>
            <ul class="yaoqiu">
                <li>经验要求：不限</li>
                <li>职位性质：全职</li>
                <li>学历要求：不限</li>
                <li>招聘人数：1人</li>
            </ul>
            <p>职位描述</p>
            <p>岗位职责：<br>
                1.有生产装配车间工作经验，熟练操作生产工艺工具，如扳手，钻床，电批，恒温焊台等。<br>
                2.能看懂简易装配图。<br>
            </p>
            <ul class="contact">
                <li>工作地点:{{addressLocat}}</li>
                <li>邮箱1:{{email1}}</li>
                <li>邮箱2:{{email2}}</li>
                <li>联系电话:{{phone}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "recruitment",
        data(){
            return{
                addressLocat:"广东/广州 广州市黄埔区玉树工业园西南门J2栋402",
                email1:"zujun.deng@MK体育 - MK(中国)一站式服务官方网站.tech",
                email2:"simian.xu@MK体育 - MK(中国)一站式服务官方网站.tech",
                phone:"020-31704431,15360825269"
            }
        }
    }
</script>

<style scoped>
    ul{
        list-style: none;
    }
    .recruitmentContainer{
        width: 1240px;
        margin: 0 auto;
    }
    .recruitmentContainer>div{
        margin-bottom: 25px;
    }
    .recruitmentContainer>div h1,h3{
        color: #005DAB;
        margin-bottom: 10px;
        position: relative;
    }
    .recruitmentContainer .item h3::before{
        border: 5px solid transparent;
        content: "";
        width: 1px;
        height: 20px;
        position: absolute;
        left: -15px;
        top: 10px;
        border-top:10px solid #005DAB ;
    }
    .recruitmentContainer>div .yaoqiu{
        margin-bottom: 10px;
    }
    .flex {
        display: flex;
        justify-items: center;
    }
    .contact{
        margin-top: 10px;
    }
</style>
